


























































import { Vue, Component, Ref, Mixins } from "vue-property-decorator";
import RequestData from "@/store/types/RequestData";
import { RegisterHttp } from "@/utils/Decorators";
import { currentCompanyStore, currentScoutingStore } from "@/store/typed";
import { SEARCH_PLACE_TAG } from "@/mixins/http/GooglePlaceMixin";
import GooglePlaceMixin from "@/mixins/http/GooglePlaceMixin";

@Component({})
export default class PoiSearch extends Mixins(GooglePlaceMixin) {
  @RegisterHttp(SEARCH_PLACE_TAG) readonly searchRequest!: RequestData;
  @Ref() readonly uploadFile!: HTMLInputElement;

  private mode: "google" | "excel" = "google";

  private term = "";

  private document: File | null = null;

  get isGoogle() {
    return this.mode === "google";
  }
  get isExcel() {
    return this.mode === "excel";
  }

  get documentName() {
    return this.document ? this.document.name : "";
  }

  get buttonLabel() {
    if (this.documentName === "") {
      return "Scegli";
    }
    return "Upload";
  }

  search() {
    currentCompanyStore.clearMarkers();
    this.$router.push({
      name: "company-poi-search",
      params: { term: this.term },
    });
  }
  browse() {
    this.uploadFile.click();
  }
  upload() {
    if (this.document) {
      this.$emit("upload", this.document);
      this.document = null;
    } else {
      this.browse();
    }
  }
  onDocument(e: any) {
    if (e.target && e.target.files) {
      this.document = e.target.files[0];
    }
  }
}
